import React, { useState, useEffect, useCallback } from 'react';
import './AdminCupones.css';

const API      = 'https://centrocomunicar.com/api-comunicar/endpoints/cupones.php';
const API_PROD = 'https://centrocomunicar.com/api-comunicar/endpoints/recursos_paga.php';
const API_CUR  = 'https://centrocomunicar.com/api-comunicar/endpoints/courses.php';

/* ── Icons ── */
const IconClose   = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/><line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>);
const IconCheck   = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><polyline points="20 6 9 17 4 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>);
const IconPlus    = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><line x1="12" y1="5" x2="12" y2="19" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><line x1="5" y1="12" x2="19" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconEdit    = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconTrash   = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><polyline points="3 6 5 6 21 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M10 11v6M14 11v6M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconEye     = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" strokeWidth="2"/><circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2"/></svg>);
const IconCopy    = () => (<svg viewBox="0 0 24 24" fill="none" width="13" height="13"><rect x="9" y="9" width="13" height="13" rx="2" stroke="currentColor" strokeWidth="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconRefresh = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M23 4v6h-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M20.49 15a9 9 0 11-2.12-9.36L23 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconTag     = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><line x1="7" y1="7" x2="7.01" y2="7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);

const TIPOS_APLICA = [
  { val:'todos',     label:'Todos los productos' },
  { val:'recursos',  label:'Solo materiales/recursos' },
  { val:'cursos',    label:'Solo cursos' },
  { val:'especifico',label:'Productos específicos' },
];

const FORM_VACIO = {
  codigo:'', descripcion:'', tipo:'porcentaje', valor:'',
  monto_minimo:'', usos_max:'', activo:true,
  fecha_inicio:'', fecha_fin:'',
  aplica_a:'todos', productos_ids:[],
};

function fmtFecha(d) {
  if (!d) return '—';
  return new Date(d).toLocaleDateString('es-PE', {day:'2-digit',month:'short',year:'numeric'});
}
function generarCodigo() {
  const chars = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789';
  let code = '';
  for (let i = 0; i < 8; i++) code += chars[Math.floor(Math.random()*chars.length)];
  return code;
}

export default function AdminCupones() {
  const [cupones,    setCupones]    = useState([]);
  const [loading,    setLoading]    = useState(false);
  const [toast,      setToast]      = useState(null);
  const [modal,      setModal]      = useState(null);   // null | 'nuevo' | id
  const [form,       setForm]       = useState(FORM_VACIO);
  const [guardando,  setGuardando]  = useState(false);
  const [copied,     setCopied]     = useState(null);
  const [modalUsos,  setModalUsos]  = useState(null);
  const [usos,       setUsos]       = useState([]);
  const [loadUsos,   setLoadUsos]   = useState(false);
  const [busqueda,   setBusqueda]   = useState('');

  // Productos para selector específico
  const [recursos,   setRecursos]   = useState([]);
  const [cursos,     setCursos]     = useState([]);
  const [loadProd,   setLoadProd]   = useState(false);

  const showToast = (msg, tipo='ok') => { setToast({msg,tipo}); setTimeout(()=>setToast(null),3000); };

  const fetchCupones = useCallback(async () => {
    setLoading(true);
    try {
      const r = await fetch(API + '?action=list');
      const j = await r.json();
      if (j.success) setCupones(j.data || []);
      else showToast(j.message, 'error');
    } catch { showToast('Error de conexión', 'error'); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { fetchCupones(); }, [fetchCupones]);

  // Cargar productos cuando se abre modal con aplica_a=especifico
  useEffect(() => {
    if (form.aplica_a !== 'especifico') return;
    if (recursos.length > 0 || cursos.length > 0) return;
    setLoadProd(true);
    Promise.all([
      fetch(API_PROD + '?action=admin_list').then(r=>r.json()),
      fetch(API_CUR  + '?action=list').then(r=>r.json()),
    ]).then(([jr, jc]) => {
      if (jr.success) setRecursos(jr.data || []);
      if (jc.success) setCursos(jc.data || []);
    }).catch(()=>{}).finally(()=>setLoadProd(false));
  }, [form.aplica_a]);

  function setF(k, v) { setForm(p => ({ ...p, [k]: v })); }

  function abrirNuevo() {
    setForm({ ...FORM_VACIO, codigo: generarCodigo() });
    setModal('nuevo');
  }

  function abrirEditar(c) {
    setForm({
      codigo:       c.codigo,
      descripcion:  c.descripcion || '',
      tipo:         c.tipo,
      valor:        c.valor,
      monto_minimo: c.monto_minimo || '',
      usos_max:     c.usos_max ?? '',
      activo:       c.activo,
      fecha_inicio: c.fecha_inicio || '',
      fecha_fin:    c.fecha_fin    || '',
      aplica_a:     c.aplica_a,
      productos_ids: c.productos_ids || [],
    });
    setModal(c.id);
  }

  // Toggle producto específico
  function toggleProducto(tipo, id, titulo) {
    const ids = form.productos_ids || [];
    const exists = ids.find(p => p.tipo === tipo && p.id === id);
    if (exists) {
      setF('productos_ids', ids.filter(p => !(p.tipo===tipo && p.id===id)));
    } else {
      setF('productos_ids', [...ids, { tipo, id, titulo }]);
    }
  }
  function productoSeleccionado(tipo, id) {
    return (form.productos_ids||[]).some(p => p.tipo===tipo && p.id===id);
  }

  async function guardar() {
    if (!form.codigo.trim()) { showToast('El código es obligatorio', 'error'); return; }
    if (!form.valor)         { showToast('El valor es obligatorio', 'error'); return; }
    if (form.aplica_a === 'especifico' && (!form.productos_ids || form.productos_ids.length === 0)) {
      showToast('Selecciona al menos un producto', 'error'); return;
    }
    setGuardando(true);
    try {
      const isNuevo = modal === 'nuevo';
      const r = await fetch(API + '?action=' + (isNuevo ? 'crear' : 'editar'), {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ ...form, id: isNuevo ? undefined : modal }),
      });
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      showToast(isNuevo ? 'Cupón creado' : 'Cupón actualizado');
      setModal(null);
      fetchCupones();
    } catch(e) { showToast(e.message, 'error'); }
    finally { setGuardando(false); }
  }

  async function toggleActivo(c) {
    try {
      const r = await fetch(API + '?action=toggle', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ id: c.id, activo: !c.activo }),
      });
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      showToast(c.activo ? 'Cupón desactivado' : 'Cupón activado');
      fetchCupones();
    } catch(e) { showToast(e.message, 'error'); }
  }

  async function eliminar(c) {
    if (!window.confirm(`¿Eliminar el cupón "${c.codigo}"?`)) return;
    try {
      const r = await fetch(API + '?action=eliminar', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ id: c.id }),
      });
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      showToast('Cupón eliminado');
      fetchCupones();
    } catch(e) { showToast(e.message, 'error'); }
  }

  async function verUsos(c) {
    setModalUsos(c); setUsos([]); setLoadUsos(true);
    try {
      const r = await fetch(API + '?action=usos&id=' + c.id);
      const j = await r.json();
      if (j.success) setUsos(j.data || []);
    } catch {}
    finally { setLoadUsos(false); }
  }

  function copiar(codigo) {
    navigator.clipboard.writeText(codigo);
    setCopied(codigo);
    setTimeout(() => setCopied(null), 2000);
    showToast('Código copiado');
  }

  const hoy = new Date().toISOString().split('T')[0];
  const filtrados = cupones.filter(c => {
    const q = busqueda.toLowerCase();
    return !q || c.codigo.toLowerCase().includes(q) || (c.descripcion||'').toLowerCase().includes(q);
  });

  // KPIs
  const activos    = cupones.filter(c => c.activo).length;
  const totalUsos  = cupones.reduce((a,c) => a + c.usos_actuales, 0);
  const totalDesc  = cupones.reduce((a,c) => a + c.total_descontado, 0);
  const vencidos   = cupones.filter(c => c.fecha_fin && c.fecha_fin < hoy).length;

  return (
    <div className="ac-page">

      {toast && (
        <div className={'ac-toast ac-toast--' + (toast.tipo==='ok'?'ok':'err')}>
          {toast.tipo==='ok'?<IconCheck/>:<IconClose/>} {toast.msg}
        </div>
      )}

      {/* HEADER */}
      <div className="ac-header">
        <div>
          <h1>Cupones de descuento</h1>
          <p>Crea y gestiona códigos de descuento para tus clientes</p>
        </div>
        <div className="ac-header__actions">
          <button className="ac-btn-ghost" onClick={fetchCupones}><IconRefresh/> Sincronizar</button>
          <button className="ac-btn-primary" onClick={abrirNuevo}><IconPlus/> Nuevo cupón</button>
        </div>
      </div>

      {/* KPIs */}
      <div className="ac-kpis">
        <div className="ac-kpi ac-kpi--verde">
          <p>Cupones activos</p>
          <strong>{activos}</strong>
          <span>de {cupones.length} totales</span>
        </div>
        <div className="ac-kpi">
          <p>Total usos</p>
          <strong>{totalUsos}</strong>
          <span>veces aplicados</span>
        </div>
        <div className="ac-kpi">
          <p>Total descontado</p>
          <strong>S/. {totalDesc.toFixed(2)}</strong>
          <span>en todos los cupones</span>
        </div>
        <div className="ac-kpi ac-kpi--rojo">
          <p>Vencidos</p>
          <strong>{vencidos}</strong>
          <span>ya no son válidos</span>
        </div>
      </div>

      {/* TOOLBAR */}
      <div className="ac-toolbar">
        <div className="ac-search">
          <input type="text" placeholder="Buscar por código o descripción…"
            value={busqueda} onChange={e=>setBusqueda(e.target.value)}/>
          {busqueda && <button onClick={()=>setBusqueda('')}><IconClose/></button>}
        </div>
        <span className="ac-count">{filtrados.length} cupones</span>
      </div>

      {/* TABLA */}
      <div className="ac-card">
        <table className="ac-tabla">
          <thead>
            <tr>
              <th>Código</th>
              <th>Descripción</th>
              <th>Descuento</th>
              <th>Aplica a</th>
              <th>Usos</th>
              <th>Vigencia</th>
              <th>Estado</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan="8" className="ac-loading">Cargando cupones…</td></tr>
            ) : filtrados.length === 0 ? (
              <tr><td colSpan="8" className="ac-empty">
                {cupones.length === 0 ? 'No hay cupones. Crea el primero.' : 'Sin resultados'}
              </td></tr>
            ) : filtrados.map(c => {
              const vencido = c.fecha_fin && c.fecha_fin < hoy;
              const agotado = c.usos_max !== null && c.usos_actuales >= c.usos_max;
              return (
                <tr key={c.id} className={'ac-tr ' + (!c.activo||vencido||agotado?'ac-tr--off':'')}>
                  <td>
                    <div className="ac-codigo-wrap">
                      <span className="ac-codigo">{c.codigo}</span>
                      <button className="ac-copy-btn" onClick={()=>copiar(c.codigo)} title="Copiar">
                        {copied===c.codigo ? '✓' : <IconCopy/>}
                      </button>
                    </div>
                  </td>
                  <td>
                    <span className="ac-desc">{c.descripcion || '—'}</span>
                  </td>
                  <td>
                    <span className={'ac-valor ac-valor--'+(c.tipo==='porcentaje'?'pct':'fijo')}>
                      {c.tipo==='porcentaje' ? `${c.valor}% OFF` : `S/. ${parseFloat(c.valor).toFixed(2)} OFF`}
                    </span>
                    {c.monto_minimo > 0 && (
                      <span className="ac-minimo">Mín. S/. {parseFloat(c.monto_minimo).toFixed(2)}</span>
                    )}
                  </td>
                  <td>
                    <span className="ac-aplica">{TIPOS_APLICA.find(t=>t.val===c.aplica_a)?.label || c.aplica_a}</span>
                  </td>
                  <td>
                    <div className="ac-usos">
                      <strong>{c.usos_actuales}</strong>
                      <span>{c.usos_max !== null ? `/ ${c.usos_max}` : '/ ∞'}</span>
                    </div>
                    {c.total_descontado > 0 && (
                      <span className="ac-descontado">S/. {parseFloat(c.total_descontado).toFixed(2)} desc.</span>
                    )}
                  </td>
                  <td>
                    <div className="ac-vigencia">
                      {c.fecha_inicio && <span>Desde {fmtFecha(c.fecha_inicio)}</span>}
                      {c.fecha_fin
                        ? <span className={vencido?'ac-vencido':''}>{vencido?'Venció':'Hasta'} {fmtFecha(c.fecha_fin)}</span>
                        : <span className="ac-sin-fin">Sin vencimiento</span>
                      }
                    </div>
                  </td>
                  <td>
                    <button
                      className={'ac-toggle ' + (c.activo&&!vencido&&!agotado?'ac-toggle--on':'ac-toggle--off')}
                      onClick={()=>toggleActivo(c)}
                    >
                      {c.activo && !vencido && !agotado ? '● Activo' : vencido ? '✕ Vencido' : agotado ? '✕ Agotado' : '○ Inactivo'}
                    </button>
                  </td>
                  <td>
                    <div className="ac-acciones">
                      <button className="ac-icon-btn ac-icon-btn--eye"   onClick={()=>verUsos(c)}    title="Ver usos"><IconEye/></button>
                      <button className="ac-icon-btn ac-icon-btn--edit"  onClick={()=>abrirEditar(c)} title="Editar"><IconEdit/></button>
                      <button className="ac-icon-btn ac-icon-btn--trash" onClick={()=>eliminar(c)}   title="Eliminar"><IconTrash/></button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* ════ MODAL CREAR/EDITAR ════ */}
      {modal !== null && (
        <div className="ac-overlay" onClick={()=>setModal(null)}>
          <div className="ac-modal" onClick={e=>e.stopPropagation()}>

            <div className="ac-modal__head">
              <div style={{display:'flex',alignItems:'center',gap:'.6rem'}}>
                <IconTag/>
                <h2>{modal==='nuevo' ? 'Nuevo cupón' : 'Editar cupón'}</h2>
              </div>
              <button className="ac-modal__close" onClick={()=>setModal(null)}><IconClose/></button>
            </div>

            <div className="ac-modal__body">

              {/* Código */}
              <div className="ac-field ac-field--full">
                <label>Código del cupón <span className="ac-req">*</span></label>
                <div style={{display:'flex',gap:'.5rem'}}>
                  <input
                    type="text" placeholder="Ej: PROMO20"
                    value={form.codigo}
                    onChange={e=>setF('codigo', e.target.value.toUpperCase())}
                    style={{flex:1, fontFamily:'monospace', fontWeight:700, letterSpacing:'.08em', fontSize:'1rem'}}
                  />
                  <button className="ac-btn-gen" onClick={()=>setF('codigo', generarCodigo())}>
                    Generar
                  </button>
                </div>
                <small>Solo letras mayúsculas, números y guiones. Sin espacios.</small>
              </div>

              {/* Descripción */}
              <div className="ac-field ac-field--full">
                <label>Descripción interna</label>
                <input type="text" placeholder="Ej: Campaña lanzamiento mayo 2026"
                  value={form.descripcion} onChange={e=>setF('descripcion', e.target.value)}/>
              </div>

              {/* Tipo y valor */}
              <div className="ac-separator">Descuento</div>
              <div className="ac-field">
                <label>Tipo de descuento <span className="ac-req">*</span></label>
                <div className="ac-tipo-sel">
                  <button
                    className={'ac-tipo-btn '+(form.tipo==='porcentaje'?'ac-tipo-btn--active':'')}
                    onClick={()=>setF('tipo','porcentaje')}
                  >
                    <span>%</span>
                    <div><strong>Porcentaje</strong><small>Ej: 20% del total</small></div>
                  </button>
                  <button
                    className={'ac-tipo-btn '+(form.tipo==='fijo'?'ac-tipo-btn--active':'')}
                    onClick={()=>setF('tipo','fijo')}
                  >
                    <span>S/.</span>
                    <div><strong>Monto fijo</strong><small>Ej: S/. 15 de descuento</small></div>
                  </button>
                </div>
              </div>

              <div className="ac-field">
                <label>
                  {form.tipo==='porcentaje' ? 'Porcentaje (%)' : 'Monto fijo (S/.)'} <span className="ac-req">*</span>
                </label>
                <input type="number" min="0" step={form.tipo==='porcentaje'?'1':'0.01'}
                  max={form.tipo==='porcentaje'?'100':undefined}
                  placeholder={form.tipo==='porcentaje'?'20':'15.00'}
                  value={form.valor} onChange={e=>setF('valor', e.target.value)}/>
                {form.tipo==='porcentaje' && form.valor > 100 && (
                  <small style={{color:'#dc2626'}}>El porcentaje no puede superar 100%</small>
                )}
              </div>

              <div className="ac-field">
                <label>Monto mínimo de compra (S/.)</label>
                <input type="number" min="0" step="0.01" placeholder="0 = sin mínimo"
                  value={form.monto_minimo} onChange={e=>setF('monto_minimo', e.target.value)}/>
              </div>

              {/* Límites */}
              <div className="ac-separator">Límites y vigencia</div>
              <div className="ac-field">
                <label>Usos máximos</label>
                <input type="number" min="1" placeholder="Vacío = sin límite"
                  value={form.usos_max} onChange={e=>setF('usos_max', e.target.value)}/>
              </div>

              <div className="ac-field">
                <label>Activo</label>
                <label className="ac-check-label">
                  <input type="checkbox" checked={!!form.activo} onChange={e=>setF('activo',e.target.checked)}/>
                  <span>Cupón activo (disponible para usar)</span>
                </label>
              </div>

              <div className="ac-field">
                <label>Fecha de inicio</label>
                <input type="date" value={form.fecha_inicio} onChange={e=>setF('fecha_inicio',e.target.value)}/>
              </div>

              <div className="ac-field">
                <label>Fecha de vencimiento</label>
                <input type="date" value={form.fecha_fin} min={form.fecha_inicio||hoy}
                  onChange={e=>setF('fecha_fin',e.target.value)}/>
              </div>

              {/* Aplica a */}
              <div className="ac-separator">¿Dónde aplica?</div>
              <div className="ac-field ac-field--full">
                <label>Aplica a</label>
                <div className="ac-aplica-sel">
                  {TIPOS_APLICA.map(t => (
                    <button key={t.val}
                      className={'ac-aplica-btn '+(form.aplica_a===t.val?'ac-aplica-btn--active':'')}
                      onClick={()=>setF('aplica_a', t.val)}
                    >{t.label}</button>
                  ))}
                </div>
              </div>

              {/* Productos específicos */}
              {form.aplica_a === 'especifico' && (
                <div className="ac-field ac-field--full">
                  <label>Selecciona los productos <span className="ac-req">*</span></label>
                  {loadProd ? (
                    <div className="ac-loading-prod">Cargando productos…</div>
                  ) : (
                    <div className="ac-prods-sel">
                      {/* Productos seleccionados */}
                      {(form.productos_ids||[]).length > 0 && (
                        <div className="ac-prods-tags">
                          {(form.productos_ids||[]).map((p,i) => (
                            <span key={i} className="ac-prod-tag">
                              {p.tipo==='curso'?'🎓':'📄'} {p.titulo}
                              <button onClick={()=>toggleProducto(p.tipo, p.id, p.titulo)}><IconClose/></button>
                            </span>
                          ))}
                        </div>
                      )}
                      {/* Lista recursos */}
                      {recursos.filter(r=>r.activo).length > 0 && (
                        <>
                          <p className="ac-prods-group">📄 Materiales / Recursos</p>
                          <div className="ac-prods-lista">
                            {recursos.filter(r=>r.activo).map(r => (
                              <label key={r.id} className={'ac-prod-item '+(productoSeleccionado('recurso',r.id)?'ac-prod-item--sel':'')}>
                                <input type="checkbox"
                                  checked={productoSeleccionado('recurso',r.id)}
                                  onChange={()=>toggleProducto('recurso',r.id,r.titulo)}/>
                                <span>{r.titulo}</span>
                                <strong>S/. {parseFloat(r.precio).toFixed(2)}</strong>
                              </label>
                            ))}
                          </div>
                        </>
                      )}
                      {/* Lista cursos */}
                      {cursos.filter(c=>c.precio_web>0).length > 0 && (
                        <>
                          <p className="ac-prods-group">🎓 Cursos</p>
                          <div className="ac-prods-lista">
                            {cursos.filter(c=>c.precio_web>0).map(c => (
                              <label key={c.id} className={'ac-prod-item '+(productoSeleccionado('curso',c.id)?'ac-prod-item--sel':'')}>
                                <input type="checkbox"
                                  checked={productoSeleccionado('curso',c.id)}
                                  onChange={()=>toggleProducto('curso',c.id,c.fullname)}/>
                                <span>{c.fullname}</span>
                                <strong>S/. {parseFloat(c.precio_web).toFixed(2)}</strong>
                              </label>
                            ))}
                          </div>
                        </>
                      )}
                    </div>
                  )}
                </div>
              )}

              {/* Preview */}
              {form.codigo && form.valor && (
                <div className="ac-field ac-field--full">
                  <div className="ac-preview-cupon">
                    <div className="ac-preview-cupon__left">
                      <span>Vista previa</span>
                      <strong>{form.codigo}</strong>
                      <small>{form.descripcion || 'Sin descripción'}</small>
                    </div>
                    <div className="ac-preview-cupon__right">
                      <span>{form.tipo==='porcentaje' ? `${form.valor}% OFF` : `S/. ${parseFloat(form.valor||0).toFixed(2)} OFF`}</span>
                      {form.fecha_fin && <small>Válido hasta {fmtFecha(form.fecha_fin)}</small>}
                    </div>
                  </div>
                </div>
              )}

            </div>

            <div className="ac-modal__foot">
              <button className="ac-btn-ghost" onClick={()=>setModal(null)}>Cancelar</button>
              <button className="ac-btn-primary" onClick={guardar} disabled={guardando}>
                {guardando ? 'Guardando…' : <><IconCheck/> {modal==='nuevo'?'Crear cupón':'Guardar cambios'}</>}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ════ MODAL USOS ════ */}
      {modalUsos && (
        <div className="ac-overlay" onClick={()=>setModalUsos(null)}>
          <div className="ac-modal ac-modal--sm" onClick={e=>e.stopPropagation()}>
            <div className="ac-modal__head">
              <div>
                <h2>Usos del cupón</h2>
                <p className="ac-codigo" style={{marginTop:'.2rem'}}>{modalUsos.codigo}</p>
              </div>
              <button className="ac-modal__close" onClick={()=>setModalUsos(null)}><IconClose/></button>
            </div>
            <div className="ac-modal__body">
              {loadUsos ? (
                <div className="ac-loading">Cargando usos…</div>
              ) : usos.length === 0 ? (
                <div className="ac-empty">Este cupón aún no ha sido usado.</div>
              ) : (
                <div className="ac-usos-tabla-wrap">
                  <table className="ac-tabla ac-tabla--sm">
                    <thead>
                      <tr><th>Email</th><th>Pedido</th><th>Monto orig.</th><th>Descuento</th><th>Monto final</th><th>Fecha</th></tr>
                    </thead>
                    <tbody>
                      {usos.map(u => (
                        <tr key={u.id} className="ac-tr">
                          <td>{u.email||'—'}</td>
                          <td><span className="ac-codigo" style={{fontSize:'.72rem'}}>{u.pedido_codigo||'—'}</span></td>
                          <td>S/. {parseFloat(u.monto_orig).toFixed(2)}</td>
                          <td style={{color:'#4db88a',fontWeight:700}}>− S/. {parseFloat(u.descuento).toFixed(2)}</td>
                          <td><strong>S/. {parseFloat(u.monto_final).toFixed(2)}</strong></td>
                          <td style={{fontSize:'.75rem',color:'#5a6a63'}}>{u.created_at?.split('T')[0]||u.created_at}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
            <div className="ac-modal__foot">
              <button className="ac-btn-ghost" onClick={()=>setModalUsos(null)}>Cerrar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}